"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var SystemModule = /** @class */ (function (_super) {
    __extends(SystemModule, _super);
    function SystemModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询oms账号权限管理列表
     * @param params
     * @param token
     */
    SystemModule.prototype.getUserDataList = function (params, token) {
        return this.gatewayClient.getUserDataList(params, token);
    };
    /**
     * 获取所有的用户群组列表
     * @param token
     */
    SystemModule.prototype.listAllGroups = function (token) {
        return this.gatewayClient.listAllGroups(token);
    };
    /**
     * 区县列表
     *
     *  @param rows 行数
     *  @param provinceId 所属省份Id
     *  @param page 页数
     *  @param sort 排序方式
     *  @param search 查询关键字
     *  @param orderBy 排序字段
     *  @param cityId 所属城市Id
     */
    SystemModule.prototype.getDistrictCounties = function (params, token) {
        return this.gatewayClient.getDistrictCounties(params, token);
    };
    /**
     * 城市列表
     *
     *  @param sort 排序方式
     *  @param provinceId 所属省份Id
     *  @param page 页数
     *  @param orderBy 排序字段
     *  @param isHotCity 是否为热门城市 1是0否
     *  @param search 查询关键字
     *  @param rows 行数
     */
    SystemModule.prototype.getDistrictCities = function (params, token) {
        return this.gatewayClient.getDistrictCities(params, token);
    };
    /**
     * 查询门店
     * @param chainName
     * @param city
     * @param token
     */
    SystemModule.prototype.searchChain = function (params, token) {
        return this.gatewayClient.searchChain(params, token);
    };
    /**
     * 新建oms用户
     * @param groupIds
     * @param password
     * @param username
     * @param token
     */
    SystemModule.prototype.addUser = function (groupIds, password, username, token) {
        return this.gatewayClient.addUser(groupIds, password, username, token);
    };
    /**
     * 编辑oms用户
     * @param groupIds
     * @param password
     * @param username
     * @param token
     */
    SystemModule.prototype.editUser = function (param, token) {
        return this.gatewayClient.editUser(param, token);
    };
    /**
     * 删除oms用户
     * @param userId
     * @param token
     */
    SystemModule.prototype.deleteUser = function (userId, token) {
        return this.gatewayClient.deleteUser(userId, token);
    };
    /**
     * 获取oms用户群组
     * @param userId
     * @param token
     */
    SystemModule.prototype.userGroups = function (userId, token) {
        return this.gatewayClient.userGroups(userId, token);
    };
    /**
     * oms删除用户房间数据范围
     * @param id
     * @param token
     */
    SystemModule.prototype.deleteOmsUserRoomsRange = function (id, token) {
        return this.gatewayClient.deleteOmsUserRoomsRange(id, token);
    };
    /**
     * oms查询用户房间数据范围
     * @param userId
     * @param token
     */
    SystemModule.prototype.getOmsUserRoomsRange = function (userId, token) {
        return this.gatewayClient.getOmsUserRoomsRange(userId, token);
    };
    /**
     * 删除所有房间数据权限
     * @param userId
     * @param token
     */
    SystemModule.prototype.deleteAllUserRoomsRange = function (userId, token) {
        return this.gatewayClient.deleteAllUserRoomsRange(userId, token);
    };
    /**
     * oms添加用户房间数据范围
     * @param isAll
     * @param type 房间数据范围类型，1城市2行政区3门店
     * @param userId
     * @param value
     * @param token
     */
    SystemModule.prototype.addOmsUserRoomsRange = function (param, token) {
        return this.gatewayClient.addOmsUserRoomsRange(param, token);
    };
    /**
     * 加所有房间数据权限
     * @param userId
     * @param token
     */
    SystemModule.prototype.addAllUserRoomsRange = function (userId, token) {
        return this.gatewayClient.addAllUserRoomsRange(userId, token);
    };
    /**
     * oms查询用户房间数据范围
     * @param userId
     * @param token
     */
    SystemModule.prototype.listRangeByUserId = function (userId, token) {
        return this.gatewayClient.listRangeByUserId(userId, token);
    };
    return SystemModule;
}(gateway_module_1.GatewayModule));
exports.SystemModule = SystemModule;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/system/index.js
// module id = 223
// module chunks = 44